import { Beacon } from '../Beacon';
import { AdserverRequestId, BeaconType } from '../types';
import { getBaseParams } from '../utils/getBaseParams';

export const dispatchImaClick = (arid: AdserverRequestId) => {
  return new Beacon({
    data: {
      type: BeaconType.imaClick,
      arid,
      ...getBaseParams(arid)
    }
  });
};
